import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {HttpService} from '../../http-utility/http.service';
import {FormBuilder} from '@angular/forms';

@Injectable()
export class DashboardService extends HttpService {

  apiUrl: string = environment.apiUrl;

  constructor(protected http: HttpClient, protected fb: FormBuilder) {
    super(http);
  }

  creaFormGroupRicerca() {
    return this.fb.group({
      vclTipologia: ['0'],
      vclKmDa: [0],
      vclKmA: [0],
      vclAnnoDa: [0],
      vclAnnoA: [0]
    });
  }
}
